export default __webpack_public_path__ + "static/410-8b37c941f1c7667ca71883c55f2ccd83.jpg";